var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFarmIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.182,
    height: 14.484,
    viewBox: "0 0 16.182 14.484",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9249",
    "data-name": "Group 9249",
    transform: "translate(-118.395 -55.924)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9899",
    "data-name": "Path 9899",
    d: "M13.872,6.261l-1.882-2.9L7.925,2.186,3.978,3.278l-1.8,2.983v8.223H13.845Z",
    transform: "translate(118.396 55.924)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9900",
    "data-name": "Path 9900",
    d: "M15.348,6.575,12.623,2.461,7.915,1.051,2.849,2.821.885,6.537,0,6.069,2.148,2.007,7.892,0l5.364,1.607,2.926,4.416Z",
    transform: "translate(118.396 55.924)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarmIcon);
export default __webpack_public_path__ + "static/media/FarmIcon.f690283cb2805198af886e92387d0951.svg";
export { ForwardRef as ReactComponent };